import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';

import GridCellContent from './GridCellContent';
import SlideShow from './SlideShow';

class GridCell extends Component {
  state = {
    isInViewPort: false,
  }
  handleEnter() {
    this.setState({ isInViewPort: true });
  }
  handleLeave() {
    this.setState({ isInViewPort: false });
  }
  render() {
    const { gridCell } = this.props;
    const inViewClass = this.state.isInViewPort ? 'lockup--animate-in' : '';

    if (gridCell.type === 'slideshow-auto') {
      if (gridCell.fadeInOut === 'true') {
        return (
          <Waypoint bottomOffset="20%" onEnter={() => this.handleEnter()} onLeave={() => this.handleLeave()}>
            <SlideShow gridCell={gridCell} inViewClass={inViewClass} />
          </Waypoint>
        );
      } else {
        return (
          <SlideShow gridCell={gridCell} inViewClass={inViewClass} />
        );
      }
    }

    if (gridCell.fadeInOut === 'true') {
      return (
        <Waypoint bottomOffset="20%" onEnter={() => this.handleEnter()} onLeave={() => this.handleLeave()}>
          <GridCellContent gridCell={gridCell} inViewClass={inViewClass} />
        </Waypoint>
      );
    } else {
      return (
        <GridCellContent gridCell={gridCell} inViewClass={inViewClass} />
      );
    }
  } // end render
}

GridCell.propTypes = {
  gridCell: PropTypes.shape({}).isRequired,
};


export default GridCell;



// WEBPACK FOOTER //
// ./src/components/GridCell.js